import React from 'react'
import propTypes from 'prop-types'
import _ from 'lodash'
import moment from 'moment'
import { FaInbox } from 'react-icons/fa'
import classNames from 'classnames'

import Event from './Event'
import FullScreenMessage from 'components/FullScreenMessage'


export function Events(props) {
  if ( ! props.loading && props.items.length === 0) {
    return (
      <FullScreenMessage icon={<FaInbox className='text-4xl' />}>
        <span>No events found</span>
      </FullScreenMessage>
    )
  }

  return (
    <div className='ml-auto mr-auto max-w-4xl w-full pb-5'>
      {
        _.chain(props.items)
          .groupBy(item => moment(item.startDatetime).format('yyyy/MM'))
          .map(
            (items, date) => (
              <div className='pb-10'>
                <div className={classNames([
                  'text-primary-600 sticky bg-white p-5 font-bold',
                  '-ml-5 -mr-5 mb-3',
                  'shadow sm:rounded-b-lg',
                  'bg-gradient-to-t from-gray-100 to-body z-10',
                  props.dateClassName,
                ])}>
                  {date}
                </div>
                <div>
                  {_.map(
                    items,
                    item => (
                      <Event
                        {...item}
                      />
                    )
                  )}
                </div>
              </div>
            )
          ).value()
      }
    </div>
  )
}

Events.protTypes = {
  items: propTypes.arrayOf([
    propTypes.instanceOf(Event)
  ]).isRequired,
  dateClassName: propTypes.string,
}

